import { ClientInForceRequestData } from "@/models/ClientInForceRequestData";
import { InForceCaseData } from "@/models/InForceCaseData";
import { BaseService } from "./BaseService";

export class InForceCasesService extends BaseService {
  serviceName = "InForceCases";
  async get(id: string): Promise<InForceCaseData> {
    const results = await this.client.get<InForceCaseData>(
      `/api/${this.serviceName}/${id}`,
    );
    return results.data;
  }
  async getAll(): Promise<InForceCaseData[]> {
    const results = await this.client.get<InForceCaseData[]>(
      `/api/${this.serviceName}`,
    );
    return results.data;
  }
  async getClientInForce(
    request: ClientInForceRequestData,
  ): Promise<InForceCaseData[]> {
    const results = await this.client.get<InForceCaseData[]>(
      `/api/${this.serviceName}/clientcases`,
      {
        params: {
          firstName: request.firstName,
          lastName: request.lastName,
          dateOfBirth: request.dateOfBirth,
        },
      },
    );
    return results.data;
  }
}
